import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Card } from '@sm/wds-react';

const ERROR_COPY = 'It looks like we slipped!';

const ErrorCard = ({ iconOnly, ...otherProps }) => {
  return (
    <Choose>
      <When condition={iconOnly}>
        <div
          className="wds-flex wds-p-3 wds-flex--x-center wds-type--hero-2"
          data-testid="ErrorCard"
          {...otherProps}
        >
          <Icon>!</Icon>
        </div>
      </When>
      <Otherwise>
        <Card data-testid="ErrorCard">
          <div
            className="wds-flex wds-flex--x-center wds-type--section-title"
            {...otherProps}
          >
            <Icon className="wds-m-r-2">!</Icon>
            &nbsp;
            {ERROR_COPY}
          </div>
        </Card>
      </Otherwise>
    </Choose>
  );
};

ErrorCard.propTypes = {
  iconOnly: PropTypes.bool
};

ErrorCard.defaultProps = {
  iconOnly: false
};

export default ErrorCard;
